import React from "react"

import { Box, Image, Typography } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import { Event, FavoriteService } from "src/openapi"
import { useLoginContext } from "src/hooks/useLoginContext"
import { MEMBER_TYPE, RESPONSE_CODE, SNACKBAR_TYPES } from "src/modules/const"
import { useRecoilState } from "recoil"
import { ShowToast } from "src/states/showToast"
import { ShowProgress } from "src/states/showProgress"

type Prop = {
  item: Event
  handleSelected: any
  handleItem: any
}

export const EventArchiveItem = ({ item, handleSelected, handleItem }: Prop) => {
  const { t } = useTranslation("translation", { keyPrefix: "event" })

  const { accessToken, checkLoginStatus, loggedin, userType } = useLoginContext()

  const [, setShowToast] = useRecoilState(ShowToast)
  const [, setShowProgress] = useRecoilState(ShowProgress)

  const handleFavorite = (isFavorite?: number) => {
    if (isFavorite) {
      setShowProgress(true)
      FavoriteService.deleteFavorite(accessToken, item.isFavorite as number).then((res) => {
        setShowProgress(false)
        if (!checkLoginStatus(res)) {
          return
        }

        if (res.status === RESPONSE_CODE.SUCCESS) {
          let tmpItem = item
          tmpItem.isFavorite = 0
          handleItem(tmpItem)
          setShowToast({
            show: true,
            text: t("success_unfavorite"),
            type: SNACKBAR_TYPES.SUCCESS,
          })
        } else {
          setShowToast({ show: true, text: t("failed_unfavorite"), type: SNACKBAR_TYPES.ERROR })
        }
      })
    } else {
      setShowProgress(true)
      FavoriteService.createFavorite(accessToken, { eventId: item.id as number }).then((res) => {
        setShowProgress(false)
        if (!checkLoginStatus(res)) {
          return
        }

        if (res.status === RESPONSE_CODE.CREATE_SUCCESS) {
          let tmpItem = item
          tmpItem.isFavorite = res.data?.id
          handleItem(tmpItem)
          setShowToast({
            show: true,
            text: t("success_favorite"),
            type: SNACKBAR_TYPES.SUCCESS,
          })
        } else {
          setShowToast({ show: true, text: t("failed_favorite"), type: SNACKBAR_TYPES.ERROR })
        }
      })
    }
  }

  const handleItemClicked = (event: any) => {
    if (event.target.id !== "favorite_action") {
      handleSelected(item)
    }
  }

  return (
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      sx={{
        borderRadius: "10px",
        p: "10px",
        bgcolor: "white",
      }}
      onClick={(event) => handleItemClicked(event)}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{ ":hover": { opacity: 0.8, cursor: "pointer" } }}
      >
        <Image
          src={item.imageUrl as string}
          sx={{ height: 160, width: "100%", bgcolor: "divider" }}
          alt=""
          imageStyle={{ width: "100%", height: "100%" }}
        />
        <Box sx={{ px: "10px", py: "6px", bgcolor: "#235496", position: "absolute" }}>
          <Typography.ExtraSmallText sx={{ color: "white" }}>
            {t("archived")}
          </Typography.ExtraSmallText>
        </Box>
        <Typography.DetailText
          sx={{ fontFamily: "Noto Sans JP !important", ml: "5px", color: "#C69989", mt: "10px" }}
        >
          {`${item.startTime?.slice(0, 10)} 公開`}
        </Typography.DetailText>
        <Typography.DetailText
          sx={{
            fontFamily: "Noto Sans JP !important",
            ml: "5px",
            mt: "10px",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 1,
          }}
        >
          {item.title}
        </Typography.DetailText>
      </Box>

      {loggedin && (userType === MEMBER_TYPE.USER || userType === MEMBER_TYPE.ADVISER) && (
        <>
          {item.isFavorite === 0 ? (
            <Box
              sx={{
                ml: "auto",
                mt: "10px",
                bgcolor: "#7DC522",
                px: "10px",
                py: "6px",
                borderRadius: "40px",
                ":hover": { opacity: 0.8, cursor: "pointer" },
              }}
              onClick={() => handleFavorite(undefined)}
            >
              <Typography.ExtraSmallText
                sx={{ color: "white", mx: "auto", my: "auto" }}
                id="favorite_action"
              >
                {t("favorite")}
              </Typography.ExtraSmallText>
            </Box>
          ) : (
            <Box
              sx={{
                ml: "auto",
                mt: "10px",
                bgcolor: "#D32F2F",
                px: "10px",
                py: "6px",
                borderRadius: "40px",
                ":hover": { opacity: 0.8, cursor: "pointer" },
              }}
              onClick={() => handleFavorite(1)}
            >
              <Typography.ExtraSmallText
                sx={{ color: "white", mx: "auto", my: "auto" }}
                id="favorite_action"
              >
                {t("unfavorite")}
              </Typography.ExtraSmallText>
            </Box>
          )}
        </>
      )}
    </Box>
  )
}
